import React, {useState} from 'react'
import {useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";
import {Button, Form, Input} from 'antd'
import {EyeInvisibleOutlined, EyeOutlined} from "@ant-design/icons";
import {clearSignInError, userSignIn} from "../../store/auth/user.action";

const SignInForm = ({setUser}) => {
    const [loading, setLoading] = useState(false);
    const [capsLockOn, setCapsLockOn] = useState(false);
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const handleCapsLock = (e) => {
        setCapsLockOn(e.getModifierState('CapsLock'));
    };

    const handleFinish = async (values) => {
        setLoading(true);
        try {
            await dispatch(userSignIn(values, (user) => {
                if (user) {
                    setUser(user);
                } else {
                    console.error("Sign-in failed, user not set.");
                }
            }));
        } catch (error) {
            console.error("Sign-in error:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form
            name='basic'
            layout='vertical'
            requiredMark={false}
            autoComplete='on'
            onFinish={handleFinish}
            onValuesChange={() => dispatch(clearSignInError())}
        >
            <Form.Item
                label={t('signIn.username')}
                name="username"
                rules={[
                    {
                        required: true,
                        message: t('signIn.usernameRequired'),
                    },
                ]}
            >
                <Input
                    autoFocus={true}
                    size="large"
                    type="text"
                    autoComplete="username"
                />
            </Form.Item>

            <Form.Item
                label={t('signIn.password')}
                name="password"
                rules={[
                    {
                        required: true,
                        message: t('signIn.passwordRequired'),
                    },
                ]}
                extra={capsLockOn && (
                    <span className="sign-in__caps-lock" role="status">{t('signIn.capsLockOn')}</span>
                )}
            >
                <Input.Password
                    size="large"
                    autoComplete="current-password"
                    onKeyDown={handleCapsLock}
                    onKeyUp={handleCapsLock}
                    onBlur={() => setCapsLockOn(false)}
                    iconRender={(visible) => (
                        <button
                            type="button"
                            aria-label={t(visible ? 'signIn.hidePassword' : 'signIn.showPassword')}
                        >
                            {visible ? <EyeOutlined/> : <EyeInvisibleOutlined/>}
                        </button>
                    )}
                />
            </Form.Item>

            <Form.Item className="sign-in__submit">
                <Button type='primary' htmlType='submit' size="large" block loading={loading}>
                    {t('signIn.submit')}
                </Button>
            </Form.Item>
        </Form>
    )
}

export default SignInForm;
